import { ArrowRightIcon } from "./Icons";

export function Hero() {
  return (
    <section className="hero" id="top" aria-labelledby="hero-title">
      <div className="container hero-grid">
        <div className="hero-copy" data-reveal>
          <h1 id="hero-title">
            Dari ide <span>menjadi benda nyata.</span>
          </h1>
          <p>
            Layanan desain dan 3D printing untuk prototipe, produk custom, miniatur, dan kebutuhan produksi skala kecil.
          </p>
          <div className="hero-actions">
            <a className="button button-primary" href="#order">
              Konsultasikan Proyek
              <ArrowRightIcon />
            </a>
            <a className="button button-outline" href="#karya">
              Lihat Karya
              <ArrowRightIcon />
            </a>
          </div>
          <p className="trust-line">Konsultasi awal gratis <span aria-hidden="true">•</span> Mulai dari 1 unit</p>
        </div>

        <figure className="hero-media" data-reveal>
          <img
            alt="Objek modular hasil 3D printing berwarna koral di meja kerja Morolab"
            fetchPriority="high"
            height="1024"
            src="/images/hero-studio.webp"
            width="1536"
          />
        </figure>
      </div>
    </section>
  );
}
